var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"baseBackground"},[_c('div',{staticClass:"baseBackground__inn"},[_c('h1',{staticClass:"baseBackground__title"},[_vm._t("title")],2),_vm._v(" "),_c('div',{staticClass:"baseBackground__box",class:[("baseBackground__box--m" + _vm.margin)]},[_c('div',{staticClass:"baseBackground__contents"},[_vm._t("default")],2)])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-821277e8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/Ulmar/partials/BaseBackground.vue
// module id = null
// module chunks = 